<template>
  <div class="p-6">
    <v-toolbar class="page-title" elevation="0">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn class="mr-3" @click="goHome()" v-on="on" tile small>
            <v-icon left>fa fa-chevron-left</v-icon>
            Dashboard
          </v-btn>
        </template>
        <span> Go back </span>
      </v-tooltip>
      <v-btn
        @click="createUserDialog = true"
        small
        class="mr-4"
        color="primary"
      >
        <v-icon class="mr-1" dark>fa fa-plus</v-icon>
        Create New User
      </v-btn>
      <slot name="actions"> </slot>
    </v-toolbar>
    <v-container>
      <div class="search-wrapper">
        <v-text-field
          v-model="search"
          label="Search..."
          prepend-inner-icon="fa fa-search"
          single-line
          outlined
          hide-details
          dense
        >
        </v-text-field>
        <small>
          Showing {{ searchResultsCount }} vegetables out of {{ users.length }}.
        </small>
      </div>
      <v-data-table
        v-model="selecteduser"
        :headers="headers"
        :items="users"
        :search="search"
        item-key="name"
        class="elevation-1"
        @current-items="getFiltered"
      >
        <template v-slot:item.Actions="{ item }">
          <td>
            <v-icon small class="mr-2" @click="viewuser(item)">
              fa fa-eye
            </v-icon>
            <v-icon small class="mr-2" @click="edituser(item)">
              fa fa-clone
            </v-icon>
            <v-icon color="red" small @click="deleteuser(item)">
              fa fa-trash
            </v-icon>
          </td>
        </template>
      </v-data-table>
    </v-container>

    <CreateModal
      @create-modal-visibility="changeModalVisibility()"
      v-if="createUserDialog"
      :create-dialog="createUserDialog"
      :modal-title="'Create New user'"
    ></CreateModal>
    <CreateModal
      @create-modal-visibility="changeEditModalVisibility()"
      :user-name="userName"
      :id="id"
      v-if="editUserDialog"
      :create-dialog="editUserDialog"
      :modal-title="'Edit user'"
    ></CreateModal>
    <v-snackbar v-model="snackbar" :timeout="5000">
      {{ "Sucessfully deleted! " }}

      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import * as API from "./../../api";

const CreateModal = () => import("./CreateDialog");

export default {
  name: "Users",
  components: { CreateModal },
  methods: {
    getUsers() {
      this.$api
        .get(API.endpoints.users)
        .then((response) => {
          this.users = response.data;
        })
        .catch((error) => {
          this.$notify({
            title: "Error",
            message: error,
            type: "danger",
          });
        });
    },

    viewuser(item) {
      this.$router.push({ path: "users/" + item.ID });
    },
    getFiltered(filtered) {
      this.searchResultsCount = filtered.length;
    },

    edituser(item) {
      this.userName = item.UserName;
      this.id = item.ID;
      this.editUserDialog = !this.editUserDialog;
    },

    deleteuser(item) {
      this.$api
        .delete(API.endpoints.users + "/" + item.ID)
        .then(() => {
          this.snackbar = true;
        })
        .catch(() => {
          console.log("Error deleting");
        });
    },

    changeEditModalVisibility() {
      this.editUserDialog = !this.editUserDialog;
    },
    changeModalVisibility() {
      this.createUserDialog = !this.createUserDialog;
    },

    goHome() {
      this.$router.push("/");
    },
  },
  data() {
    return {
      selecteduser: "",
      search: "",
      createUserDialog: false,
      editUserDialog: false,
      userName: "",
      headers: [
        { text: "Id", value: "ID", align: "center" },
        { text: "User Name", value: "UserName", align: "center" },
        { text: "Actions", value: "Actions" },
      ],
      users: [],
      searchResultsCount: 0,
      snackbar: false,
    };
  },
  mounted() {
    console.log("mountirali");
    this.getUsers();
  },
};
</script>

<style scoped>
.page-title {
  border-bottom: 1px solid rgba(219, 219, 219, 0.48);
  font-size: 15px;
}
</style>
